<script setup lang="ts">
import SimpleButton from "ls/components/simple-button/SimpleButton.vue";
import { SimpleDialog, SimpleDialogContent, SimpleDialogDescription, SimpleDialogFooter, SimpleDialogHeader, SimpleDialogTitle } from "ls/components/simple-dialog";
import { DialogClose } from "reka-ui";
import { computed } from "vue";
import { useAccessControl } from "./useAccessControl";

const { clear, errorType, payload } = useAccessControl();

const isOpen = computed(() => errorType.value === "viewOnlyFilesystem");

const workspaceName = computed(() => {
  const data = payload.value as { WorkspaceName?: string };
  return data?.WorkspaceName ?? "";
});

function handleDialogOpen(open: boolean) {
  if (!open) clear();
}
</script>

<template>
  <SimpleDialog
    v-if="isOpen"
    :open="isOpen"
    @update:open="handleDialogOpen"
  >
    <SimpleDialogContent>
      <SimpleDialogHeader>
        <SimpleDialogTitle>
          Get permission to create and edit files
        </SimpleDialogTitle>
        <SimpleDialogDescription class="mt-2">
          To create and edit files in <span class="font-semibold">{{ workspaceName || "this workspace" }}</span>, ask anyone who can edit this workspace to change your permission to <span class="font-semibold">can edit</span>. You are currently set to <span class="font-semibold">view only</span>.
        </SimpleDialogDescription>
      </SimpleDialogHeader>
      <SimpleDialogFooter>
        <DialogClose as-child>
          <SimpleButton
            size="large"
          >
            Got it
          </SimpleButton>
        </DialogClose>
      </SimpleDialogFooter>
    </SimpleDialogContent>
  </SimpleDialog>
</template>
